import { fetchWithAuth, fetchWithOptionalAuth } from './authService';
import { throwApiError } from './apiError';

export const createHistory = async (historyData) => {
  const response = await fetchWithAuth("/api/histories", {
    method: 'POST',
    body: JSON.stringify(historyData),
  })

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
}

export const getHistories = async () => {
  const response = await fetchWithOptionalAuth('/api/histories');

  if (response && response.ok) {
    const histories = await response.json();
    histories.sort((a, b) => a.createdAt - b.createdAt);
    return histories;
  }

  await throwApiError(response);
}

export const updateHistory = async (historyId, updateData) => {
  const response = await fetchWithAuth(`/api/histories/${historyId}`, {
    method: 'PATCH',
    body: JSON.stringify(updateData),
  });

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
}

export const deleteHistory = async (historyId) => {
  const response = await fetchWithAuth(`/api/histories/${historyId}`, {
    method: 'DELETE',
  });

  if (response && response.ok) {
    if (response.status === 204 || response.status === 200) {
      return;
    }
    return await response.json();
  }

  await throwApiError(response);
}

export const getDefaultHistorySettings = async () => {
  const response = await fetchWithOptionalAuth('/api/histories/settings');

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
}

export const getHistorySettings = async (historyId) => {
  const response = await fetchWithOptionalAuth(`/api/histories/${historyId}/settings`);

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
}

export const updateHistorySetting = async (historyId, key, value) => {
  const response = await fetchWithAuth(`/api/histories/${historyId}/settings`, {
    method: 'PATCH',
    body: JSON.stringify({ key, value })
  });

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
}

export const getHistorySettingValue = async (historyId, key) => {
  try {
    const settings = await getHistorySettings(historyId);
    
    for (const section of settings.sections) {
      const field = section.fields.find(f => f.key === key);
      if (field) {
        return field.value;
      }
    }
    
    return null;
  } catch (err) {
    console.error('Failed to get setting value:', err);
    return null;
  }
}

export const getHistorySettingRules = async (historyId, key) => {
  try {
    const settings = await getHistorySettings(historyId);
    
    for (const section of settings.sections) {
      const field = section.fields.find(f => f.key === key);
      if (field?.rules) {
        const rules = {};
        field.rules.split('|').forEach(rule => {
          const [name, value] = rule.split(':');
          if (name && value) {
            rules[name] = parseInt(value, 10);
          }
        });
        return rules;
      }
    }
    
    return null;
  } catch (err) {
    console.error('Failed to get setting rules:', err);
    return null;
  }
}